import { render, staticRenderFns } from "./DownloadToolbarButton.vue?vue&type=template&id=18eedb99&"
import script from "./DownloadToolbarButton.vue?vue&type=script&lang=js&"
export * from "./DownloadToolbarButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./DownloadToolbarButton.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18eedb99')) {
      api.createRecord('18eedb99', component.options)
    } else {
      api.reload('18eedb99', component.options)
    }
    module.hot.accept("./DownloadToolbarButton.vue?vue&type=template&id=18eedb99&", function () {
      api.rerender('18eedb99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GalleryView/Toolbar/DownloadToolbarButton.vue"
export default component.exports